import React from "react";
import { useNavigate } from "react-router";

import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";

import { routes } from "routes/routes";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { setShowLayoutBanner } from "store/features/subscriptionSlice";

import { ReactComponent as PremiumIcon } from "assets/images/icon-premium.svg";
import { ReactComponent as CloseIcon } from "assets/images/icon_close_modal.svg";

import { styles } from "./styles";

const TrialLayoutBanner: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const showBanner = useAppSelector(
    (state) => state.subscription.showLayoutBanner
  );
  const isTrial = useAppSelector(
    (state) => state.subscription.subscription?.isTrial
  );

  const daysLeft =
    useAppSelector(
      (state) => state.subscription.subscription?.subscriptionDurationDays
    ) || 0;

  const renderDays = () => {
    const rest = daysLeft % 10;

    switch (rest) {
      case 1:
        return `${daysLeft} день.`;
      case 2:
      case 3:
      case 4:
        return `${daysLeft} дні.`;
      default:
        return `${daysLeft} днів.`;
    }
  };

  const onChooseTariff = () => {
    navigate(routes.subscription);
  };

  // TODO: more smooth close - ? Use Colapse from MUI - ?
  const onClose = () => {
    dispatch(setShowLayoutBanner(false));
  };

  return (
    showBanner && (
      <Box data-testid="subs-banner" sx={styles.trialBanner}>
        <PremiumIcon style={{ flexShrink: 0 }} />
        {isTrial && (
          <Box sx={styles.trialWrapper}>
            <Typography>
              Ознайомчий період користування{" "}
              {daysLeft > 0 ? (
                <>
                  завершиться через <strong>{renderDays()}</strong>
                </>
              ) : (
                "завершився."
              )}
            </Typography>
            <Link
              color="primary.main"
              underline="none"
              component="button"
              onClick={onChooseTariff}
            >
              Обрати Тариф зараз
            </Link>
          </Box>
        )}
        {!isTrial && (
          <Typography>
            Термін дії вашої передплати завершився. Щоб надалі користуватися
            усіма можливостями сервісу, будь ласка,{" "}
            <Link
              color="primary.main"
              underline="none"
              component="button"
              variant="body1"
              onClick={onChooseTariff}
              sx={{ mb: 0.25 }}
            >
              оновіть тариф
            </Link>
          </Typography>
        )}

        <IconButton
          aria-label="close-banner"
          onClick={onClose}
          sx={styles.closeButton}
        >
          <CloseIcon />
        </IconButton>
      </Box>
    )
  );
};

export default TrialLayoutBanner;
